import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import type {DataProtectionAnonymizeScope} from '@app/services/data-protection.service';
import {ANONYMIZE_SCOPE_OPTIONS, AnonymizeScopeOption, canonicalScope} from '../data-protection-vocabulary';

@Component({
  selector: 'app-anonymize-scope-choice',
  templateUrl: './anonymize-scope-choice.component.html',
  styleUrls: ['./anonymize-scope-choice.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class AnonymizeScopeChoiceComponent {
  @Input() idPrefix = 'dp-scope';
  @Input() disabled = false;
  @Input() set value(value: DataProtectionAnonymizeScope[] | null) { this.selected = canonicalScope(value || []); }
  @Output() valueChange = new EventEmitter<DataProtectionAnonymizeScope[]>();
  options = ANONYMIZE_SCOPE_OPTIONS;
  selected: DataProtectionAnonymizeScope[] = ['advocates'];

  isChecked(option: AnonymizeScopeOption): boolean {
    return option.locked || this.selected.indexOf(option.value) !== -1;
  }

  toggle(option: AnonymizeScopeOption, checked: boolean): void {
    if (option.locked || this.disabled) {
      return;
    }
    const next = checked ? this.selected.concat(option.value) : this.selected.filter((v) => v !== option.value);
    this.selected = canonicalScope(next);
    this.valueChange.emit(this.selected);
  }
}
